import React, { useEffect, useState } from 'react';
import { Timeline } from '../models/timeline';
import { Session } from '../models/session';

type SessionTimelineContextType = {
  curriculumName: string;
  timeline: Timeline;
  setTimeline: React.Dispatch<React.SetStateAction<Timeline>>;
  session: Session;
};
const SessionTimelineContext = React.createContext<SessionTimelineContextType | undefined>(undefined);
SessionTimelineContext.displayName = 'SessionTimelineContext';

export const SessionTimelineProvider = ({
  curriculumName,
  timeline: initialTimeline,
  session,
  children,
}: {
  curriculumName: string;
  timeline: Timeline;
  session: Session;
  children: React.ReactNode;
}) => {
  const [timeline, setTimeline] = useState(initialTimeline);

  useEffect(() => {
    setTimeline(initialTimeline);
  }, [initialTimeline?.id]);

  return (
    <SessionTimelineContext.Provider value={{ curriculumName, timeline, setTimeline, session }}>
      {children}
    </SessionTimelineContext.Provider>
  );
};

export default SessionTimelineContext;
